const { displayMessage } = require('../helpers/messages')

module.exports = {
    ATIVO: { code: 2, description: displayMessage('ACTIVE') },
    INATIVO: { code: 1, description: displayMessage('INACTIVE') },
}
